export default __webpack_public_path__ + "static/media/b04.53a87d34.jpg";